import { EffectCarousel } from 'theme';
import { animate } from 'vendor';

/**
 * CountdownCarousel component for the cycling messages in the countdown timer.
 * Extends the theme's base EffectCarousel to inherit core carousel functionality.
 */
class CountdownCarousel extends EffectCarousel {
  /**
   * Defines the transition when the message changes.
   * Supports "vertical-slide" and "elastic-overshoot".
   * 
   * @param {HTMLElement} fromSlide The slide leaving the view
   * @param {HTMLElement} toSlide The slide entering the view
   * @returns {Object} Animation controls for Motion One
   */
  createOnChangeAnimationControls(fromSlide, toSlide) {
    const animationType = this.getAttribute('animation-type') || 'vertical-slide';

    if (animationType === 'elastic-overshoot') {
      return {
        // Leaving slide: fades and moves up
        leaveControls: () => animate(fromSlide, 
          { 
            opacity: [1, 0], 
            transform: ["translateY(0)", "translateY(-20px)"] 
          }, 
          { 
            duration: 0.3, 
            easing: "ease-in" 
          }
        ),
        // Entering slide: comes from below, overshoots, and settles
        // Using a custom cubic-bezier for the overshoot effect
        enterControls: () => animate(toSlide, 
          { 
            opacity: [0, 1], 
            transform: ["translateY(20px)", "translateY(0px)"] 
          }, 
          { 
            duration: 0.6, 
            easing: [0.34, 1.56, 0.64, 1] // Back out effect
          }
        )
      };
    }

    // Default: vertical-slide (matching theme's announcement bar style)
    return {
      leaveControls: () => animate(fromSlide, 
        { 
          opacity: [1, 0], 
          transform: ["translateY(0)", "translateY(-10px)"] 
        }, 
        { 
          duration: 0.25, 
          easing: [0.55, 0.055, 0.675, 0.19] 
        }
      ),
      enterControls: () => animate(toSlide, 
        { 
          opacity: [0, 1], 
          transform: ["translateY(10px)", "translateY(0px)"] 
        }, 
        { 
          duration: 0.4, 
          easing: [0.215, 0.61, 0.355, 1] 
        }
      )
    };
  }
}

if (!window.customElements.get('countdown-carousel')) {
  window.customElements.define('countdown-carousel', CountdownCarousel);
}